@if (!loading) {
  <fieldset class="sps-fieldset form-data-container" [ngClass]="paymentTypeContractData.paymentMethod !== PaymentMethodName.DIRECTTRANSFER ? 'separator' : null">
    <div class="grid w-full">
      @switch (true) {
        @case (paymentTypeContractData.paymentMethod === PaymentMethodName.CREDITCARD || paymentTypeContractData.paymentMethod === PaymentMethodName.CREDITCARD_MOTO) {
          <div class="col-6 flex flex-column gap-2">
            <label for="cardbrand">
              {{ i18n.i18nLng()['CARDBRAND'] }}<sup class="sps-sup">*</sup>
            </label>
            <p-select [(ngModel)]="paymentTypeContractData.creditCardBrand"
                      inputId="cardbrand"
                      [options]="settingsProvider.cardType"
                      [showClear]="false"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      (ngModelChange)="validateData()"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['CARDBRAND']">
            </p-select>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="acceptancepoint">
              {{ i18n.i18nLng()['CCACCEPTANCEPOINT'] }}<sup class="sps-sup">*</sup>
            </label>
            <p-select [(ngModel)]="paymentTypeContractData.creditCardAcceptancePoint"
                      inputId="acceptancepoint"
                      [options]="settingsProvider.cardAcceptancePoint"
                      [showClear]="false"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      (ngModelChange)="validateData()"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['CCACCEPTANCEPOINT']">
            </p-select>
          </div>
          <div class="col-6 flex gap-2 flex-column">
            <label for="vunumber">{{ i18n.i18nLng()['VUNUMBER'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText id="vunumber" fluid [(ngModel)]="paymentTypeContractData.vuNumber" [disabled]="true" pSize="large"/>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="contractoptions">
              {{ i18n.i18nLng()['CONTRACTOPTIONS'] }}<sup class="sps-sup">*</sup>
            </label>
            <p-select [(ngModel)]="paymentTypeContractData.contractOptions"
                      inputId="contractoptions"
                      [options]="settingsProvider.contractOptions"
                      [showClear]="false"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      (ngModelChange)="validateData()"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['CONTRACTOPTIONS']">
            </p-select>
          </div>
          <div class="col-6 flex gap-2 flex-column">
            <label for="currency">{{ i18n.i18nLng()['CURRENCY'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText id="currency" fluid [(ngModel)]="paymentTypeContractData.currency" [disabled]="true" pSize="large"/>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="mcc">MCC<sup class="sps-sup">*</sup>
            </label>
            <input pInputText
                   id="mcc"
                   maxlength="4"
                   minlength="4"
                   [(ngModel)]="paymentTypeContractData.mcc"
                   (ngModelChange)="validateData()"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [attr.aria-label]="i18n.i18nLng()['ISO18245']"
                   pSize="large"/>
            <small style="line-height: 1.5rem" id="mcc">{{ i18n.i18nLng()['ISO18245'] }}</small>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="terminalid">{{ i18n.i18nLng()['TERMINALID'] }}<sup class="sps-sup">*</sup>
            </label>
            <input pInputText
                   id="terminalid"
                   maxlength="8"
                   [(ngModel)]="paymentTypeContractData.terminalId"
                   (ngModelChange)="validateData()"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [attr.aria-label]="i18n.i18nLng()['TERMINALID']"
                   pSize="large"/>
          </div>
        }
        @case (paymentTypeContractData.paymentMethod === PaymentMethodName.PAYPAL) {
          <div class="col-12 flex flex-column gap-2">
            <label for="paypalemail">{{ i18n.i18nLng()['PAYPALEMAIL'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText id="paypalemail" fluid [(ngModel)]="paymentTypeContractData.payPalEmailAddress" [disabled]="true" pSize="large"/>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="paypalcustomerid">{{ i18n.i18nLng()['PAYPALMERCHANTID'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText id="paypalcustomerid" fluid [(ngModel)]="paymentTypeContractData.payPalMerchantId" [disabled]="true" pSize="large"/>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="paypalpartnerid">{{ i18n.i18nLng()['PAYPALPARTNERID'] }}<sup class="sps-sup">*</sup>
            </label>
            <input pInputText
                   id="paypalpartnerid"
                   [(ngModel)]="paymentTypeContractData.payPalPartnerId"
                   (ngModelChange)="validateData()"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [attr.aria-label]="i18n.i18nLng()['PAYPALPARTNERID']"
                   pSize="large"/>
          </div>
        }
        @case (paymentTypeContractData.paymentMethod === PaymentMethodName.SEPA || paymentTypeContractData.paymentMethod === PaymentMethodName.SEPA_BLACKLIST) {
          <div class="col-6 flex flex-column gap-2">
            <label for="creditorid">{{ i18n.i18nLng()['CREDITORID'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText id="creditorid" fluid [(ngModel)]="paymentTypeContractData.creditorId" [disabled]="true" pSize="large"/>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="accountholder">{{ i18n.i18nLng()['ACCOUNTHOLDER'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText id="accountholder" fluid [(ngModel)]="paymentTypeContractData.accountHolder" [disabled]="true" pSize="large"/>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="iban">{{ i18n.i18nLng()['IBAN'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText id="iban" fluid [(ngModel)]="paymentTypeContractData.IBAN" [disabled]="true" pSize="large"/>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="bic">{{ i18n.i18nLng()['BIC'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText id="bic" fluid [(ngModel)]="paymentTypeContractData.BIC" [disabled]="true" pSize="large"/>
          </div>
          <div class="col-6 flex flex-column gap-2">
            <label for="billingtype">
              {{ i18n.i18nLng()['BILLINGTYPE'] }}<sup class="sps-sup">*</sup>
            </label>
            <p-select [(ngModel)]="paymentTypeContractData.billingType"
                      inputId="billingtype"
                      [options]="settingsProvider.billingType"
                      [showClear]="false"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      (ngModelChange)="validateData()"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['BILLINGTYPE']">
            </p-select>
          </div>
          <div class="col-12 flex flex-column gap-2">
            <label for="nameonstatement">{{ i18n.i18nLng()['NAMEONBANKSTATEMENT'] }}<sup class="sps-sup">*</sup>
            </label>
            <input pInputText
                   id="nameonstatement"
                   [(ngModel)]="paymentTypeContractData.nameOnBankStatement"
                   (ngModelChange)="validateData()"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [attr.aria-label]="i18n.i18nLng()['NAMEONBANKSTATEMENT']"
                   pSize="large"/>
            <small style="line-height: 1.5rem" id="nameonstatementinfo">{{ i18n.i18nLng()['NAMEONBANKSTATEMENTINFO'] }}</small>
          </div>
          <div class="col-12 flex flex-column gap-2">
            <label for="nameonmandate">{{ i18n.i18nLng()['NAMEONSEPAMANDATE'] }}<sup class="sps-sup">*</sup>
            </label>
            <input pInputText
                   id="nameonmandate"
                   [(ngModel)]="paymentTypeContractData.nameOnSEPAMandate"
                   (ngModelChange)="validateData()"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [attr.aria-label]="i18n.i18nLng()['NAMEONSEPAMANDATE']"
                   pSize="large"/>
            <small style="line-height: 1.5rem" id="nameonmandateinfo">{{ i18n.i18nLng()['NAMEONSEPAMANDATEINFO'] }}</small>
          </div>
        }
        @case (paymentTypeContractData.paymentMethod === PaymentMethodName.APPLEPAY || paymentTypeContractData.paymentMethod === PaymentMethodName.GOOGLEPAY) {
          <div class="col-12 flex flex-column gap-2">
            <label for="activeccid">
              {{ i18n.i18nLng()['ACTIVECARDACCEPTANCE'] }}<sup class="sps-sup">*</sup>
            </label>
            <p-select [(ngModel)]="paymentTypeContractData.activeCreditCardId"
                      inputId="activeccid"
                      [options]="activeCardsList"
                      [showClear]="false"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      (ngModelChange)="validateData()"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['ACTIVECARDACCEPTANCE']">
            </p-select>
            <small style="line-height: 1.5rem" id="activeccidinfo">{{ i18n.i18nLng()['ACTIVECARDACCEPTANCEINFO'] }}</small>
          </div>
        }
      }
    </div>
  </fieldset>
}
